// Port of api/fuel/app/classes/insights/hindex/levels.php
import Segment from 'offline/insights/segment'
import Util from 'offline/util'
import Constants from 'offline/constants'

export default Segment.extend({
    name: 'levels',
    priority: 1,
    default_: true,
    requires: ['init'],
    insight: [],
    detail: [],
    types: [Constants.TYPE_USER, Constants.TYPE_GROUP, Constants.TYPE_BUDDIES],
    run: function(type, owner, userIndex, detail, filter, vars) {

        if (!this._data.track || !this._data.track.get_hindex()) return {}

        var hindexId = this._data.type.get_id()
        var ownerId = owner.get_id()

        var bumps = Util.queryFast(
            'SELECT * FROM log_user_hindex WHERE hindex_id = ' + hindexId +
            ' AND user_id = ' + ownerId +
            ' ORDER BY log_hindex DESC'
        )

        if (!bumps.length) return { levels: [] }

        // Mirror of Insights\Hindex\Levels::run — community comparison data
        // comes from the precomputed insight_community_hindex cache rather
        // than scanning the full log_user_hindex table per bump.
        var hindexValues = []
        var seenHindex = {}
        for (var bi = 0; bi < bumps.length; bi++) {
            var hv = parseInt(bumps[bi].log_hindex, 10)
            if (hv && !seenHindex[hv]) { seenHindex[hv] = true; hindexValues.push(hv) }
        }

        var cache = {}
        if (hindexValues.length) {
            var cacheRows = Util.queryFast(
                'SELECT hindex_level, field, count_positive, median_total, median_positive,' +
                ' min_v, max_v, bin_counts, bin_edges, cdf' +
                ' FROM insight_community_hindex' +
                ' WHERE hindex_id = ' + hindexId +
                ' AND hindex_level IN (' + hindexValues.join(',') + ')'
            )
            for (var ci = 0; ci < cacheRows.length; ci++) {
                var r = cacheRows[ci]
                var lvl = parseInt(r.hindex_level, 10)
                if (!cache[lvl]) cache[lvl] = {}
                cache[lvl][r.field] = {
                    count_positive: parseInt(r.count_positive, 10) || 0,
                    median_total: parseFloat(r.median_total) || 0,
                    median_positive: parseFloat(r.median_positive) || 0,
                    min_v: parseFloat(r.min_v) || 0,
                    max_v: parseFloat(r.max_v) || 0,
                    bin_counts: parseJsonArray(r.bin_counts),
                    bin_edges: parseJsonArray(r.bin_edges),
                    cdf: parseJsonArray(r.cdf)
                }
            }
        }

        var levels = []

        for (var i = 0; i < bumps.length; i++) {
            var bump = bumps[i]
            var bumpHindex = parseInt(bump.log_hindex, 10)
            var levelCache = cache[bumpHindex] || {}

            var medianTotal = function(field) {
                return levelCache[field] ? levelCache[field].median_total : 0
            }

            levels.push({
                id: String(bump.log_id),
                own: {
                    level: bumpHindex,
                    date: parseInt(bump.log_date, 10),
                    plays: parseInt(bump.log_plays_level, 10),
                    games: parseInt(bump.log_games_level, 10),
                    days: parseInt(bump.log_days, 10),
                    efficiency: parseInt(bump.log_efficiency_current, 10)
                },
                median: {
                    days: phpRound(parseInt(bump.log_days, 10) - medianTotal('days')),
                    games: phpRound(parseInt(bump.log_games_level, 10) - medianTotal('games')),
                    plays: phpRound(parseInt(bump.log_plays_level, 10) - medianTotal('plays'))
                },
                percentile: {
                    days: analyzeFromCache(levelCache, 'days', parseInt(bump.log_days, 10)),
                    games: analyzeFromCache(levelCache, 'games', parseInt(bump.log_games_level, 10)),
                    plays: analyzeFromCache(levelCache, 'plays', parseInt(bump.log_plays_level, 10)),
                    efficiency: analyzeFromCache(levelCache, 'efficiency', parseInt(bump.log_efficiency_current, 10))
                }
            })

            this._references.games.push(parseInt(bump.game_id, 10))
        }

        return {
            levels: levels
        }

    }
})

function parseJsonArray(value) {
    if (Array.isArray(value)) return value
    if (!value) return []
    try {
        var parsed = JSON.parse(value)
        return Array.isArray(parsed) ? parsed : []
    } catch (e) {
        return []
    }
}

// Mirror of analyzeFromCache() in insights/hindex/levels.php — keep in sync.
function analyzeFromCache(levelCache, field, userValue) {
    var empty = { bins: [], index: null, edges: [], percentile: null, vsMedian: null }

    if (!levelCache[field]) return empty
    var row = levelCache[field]
    var count = row.count_positive
    if (count === 0) return empty

    var bins = row.bin_counts || []
    var edges = row.bin_edges || []
    var cdf = row.cdf || []
    var median = row.median_positive
    var min = row.min_v
    var max = row.max_v

    // Exact percentile via the distinct-value CDF (sorted asc by value).
    var lessOrEqual = 0
    for (var ci = 0; ci < cdf.length; ci++) {
        var entry = cdf[ci]
        if (parseFloat(entry[0]) <= userValue) {
            lessOrEqual = parseInt(entry[1], 10)
        } else {
            break
        }
    }
    var percentile = Math.round((1 - (lessOrEqual / count)) * 100)
    percentile = Math.max(1, Math.min(99, percentile))

    var vsMedian = userValue - median

    var numBins = Math.max(1, bins.length)
    if (min <= 0 || max <= 0 || min === max) {
        return {
            bins: bins,
            index: Math.floor(numBins / 2),
            edges: edges,
            percentile: percentile,
            vsMedian: vsMedian
        }
    }

    var index = null
    if (userValue > 0) {
        var logMin = Math.log10(min)
        var logMax = Math.log10(max)
        var logRange = logMax - logMin
        if (logRange > 0) {
            var binWidth = logRange / numBins
            index = Math.min(Math.floor((Math.log10(userValue) - logMin) / binWidth), numBins - 1)
        }
    }

    // Mirror the legacy levels.php quirk where the main return path drops
    // vsMedian. Keep parity exactly — the prior in-snapshot computation
    // shipped this shape and the consumers expect it.
    return {
        bins: bins,
        index: index,
        edges: edges,
        percentile: percentile
    }
}

function phpRound(value) {
    return value >= 0 ? Math.round(value) : -Math.round(Math.abs(value))
}
